
        var result = require("!!../../../../node_modules/css-loader/index.js!./subscription-type-treatment.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/subscription-type-treatment.component.css
// module id = 2370
// module chunks = 1